<template>
  <div class="w-full">
    <TabView>
      <TabPanel v-for="item in items" :header="item?.[group_by ?? 'name']">
        <WebComponent :item="item" />
      </TabPanel>
    </TabView>
  </div>
</template>

<script setup>
const props = defineProps({
  items: {
    type: Object,
    required: true
  },
  group_by: {
    type: String
  }
})
</script>
